module.exports = __webpack_public_path__ + "static/media/_Seafood.165a5a74.jpg";